// src/components/TradesList.js
import React from 'react';
import PaginationControls from './PaginationControls';
import { ItemNotificationIndicator } from './SmartNotificationDot';
import { getStatusLabel } from '../utils/statusUtils';

const ROWS_PER_PAGE = 10;

// This component is now simpler. It displays actions based on the trade's data, not the active tab.
const TradesList = ({
    trades,
    userId,
    navigate,
    onOpenRatingModal,
    currentPage,
    onPageChange,
    userItems = [],
    onOpenChat,
    notifications = [],
    onConfirmShipment,
    onConfirmReceived
}) => {
    const totalPages = Math.ceil(trades.length / ROWS_PER_PAGE);
    const paginatedTrades = trades.slice((currentPage - 1) * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE);
    
    const getEmptyStateMessage = () => {
        if (trades.some(t => !t.status.includes('completed'))) {
            return { title: "Nenhum item aguardando ação", subtitle: "Suas transações ativas aparecerão aqui" };
        }
        return { title: "Nenhuma troca encontrada", subtitle: "Seu histórico de trocas aparecerá aqui" };
    };
    const { title, subtitle } = getEmptyStateMessage();

    return (
        <div>
            <div className="space-y-4">
                {paginatedTrades.length > 0 ? paginatedTrades.map(trade => {
                    const item = userItems.find(i => i.id === trade.itemId);
                    const isArchived = trade.status?.includes('cancel') || trade.status?.includes('completed');

                    return (
                        <div key={trade.id} className="bg-white p-3 sm:p-4 rounded-lg shadow-md flex flex-col sm:flex-row items-start sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                            <div className="flex items-center w-full">
                                <div className="relative">
                                    <img
                                        src={trade.itemImageUrl || 'https://placehold.co/100x100/e2e8f0/64748b?text=Item'}
                                        alt={trade.itemTitle}
                                        className="w-14 h-14 sm:w-16 sm:h-16 object-cover rounded-md mr-3 sm:mr-4"
                                    />
                                    <ItemNotificationIndicator itemId={trade.id} notifications={notifications} />
                                </div>
                                <div>
                                    <p className="font-semibold text-sm sm:text-base">{trade.itemTitle}</p>
                                    <p className="text-xs sm:text-sm text-gray-500">
                                        Status: <span className="font-medium">{getStatusLabel(trade.status)}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center justify-end space-x-4 w-full sm:w-auto mt-2 sm:mt-0">
                                {/* Actions are now based on trade status and user role */}
                                {trade.status === 'confirmed' && trade.sellerId === userId && onConfirmShipment && <button onClick={() => onConfirmShipment(trade)} className="text-sm text-blue-600 hover:underline font-semibold bg-blue-50 px-3 py-1 rounded">Confirmar Envio</button>}
                                {trade.status === 'entregue' && trade.buyerId === userId && onConfirmReceived && <button onClick={() => onConfirmReceived(trade)} className="text-sm text-green-600 hover:underline font-semibold bg-green-50 px-3 py-1 rounded">Confirmar Recebimento</button>}
                                
                                {!isArchived && onOpenChat && <button onClick={() => onOpenChat(trade)} className="text-sm text-blue-600 hover:underline">Abrir Chat</button>}

                                {trade.status === 'completed' && !trade.ratingsGiven?.[userId] && onOpenRatingModal && <button onClick={() => onOpenRatingModal(trade)} className="text-sm text-green-600 hover:underline font-semibold">Avaliar</button>}
                                
			    {/* <button onClick={() => navigate('trade', { tradeId: trade.id })} className="text-sm text-gray-600 hover:underline">Ver Detalhes</button> */}
			      {/* ✅ THE FIX IS HERE: Changed how navigate is called */}
                                <button onClick={() => navigate(`/trades/${trade.id}`)} className="text-sm text-gray-600 hover:underline">Ver Detalhes</button>
                            </div>
                        </div>
                    );
                }) : (
                    <div className="text-center py-12">
                        <p className="text-gray-500 text-lg font-medium">{title}</p>
                        <p className="text-gray-400 text-sm mt-1">{subtitle}</p>
                    </div>
                )}
            </div>
            <PaginationControls currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
    );
};

export default TradesList;
